jQuery(function($) {
  let $state_triggers = $('#js-states-svg a');

  function hideStateHeader() {
    $('.state-info .state-info-header').css('display', 'none');
  }

  $state_triggers.click(function() {
    hideStateHeader();
    $state_triggers.removeClass('state-active');
    $(this).addClass('state-active');
    let $card_id = $(this).attr('xlink:href');
    window.location = $card_id;
  });

  $('#js-select-state').change(function() {
    hideStateHeader();
    let $selected_state = $('#js-select-state option:selected').val();
    window.location = $selected_state;
  });

});
